module.exports = __webpack_public_path__ + "assets/media/graffiti-texture-desktop-2.0c21f58d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoController/graffiti-texture-desktop-2.svg
// module id = 3264
// module chunks = 0